export default "__VITE_ASSET__BR$sV6QJ__"